import React from 'react';
import axios from 'axios';

import { Box, Divider, useMediaQuery } from '@mui/material';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import AppAppBar from './components/AppBar';
import HeroImage from './components/HeroImage';

import About from './components/About';
import Database from './components/Database';
import Footer from './components/Footer';
import Marks from './components/Marks';
import Units from './components/Units';

export default function App() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const [mode, setMode] = React.useState(prefersDarkMode ? "dark" : "light");

  const [lastUpdated, setLastUpdated] = React.useState(null);

  const [overview, setOverview] = React.useState(null);
  const [manufacturers, setManufacturers] = React.useState([]);
  const [acceptanceMarks, setAcceptanceMarks] = React.useState([]);
  const [unitMarkings, setUnitMarkings] = React.useState([]);

  const defaultTheme = createTheme({ palette: { mode } });

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  React.useEffect(() => {
    axios.get("/api/overview")
      .then(res => {
        setOverview(res.data);
        setLastUpdated(res.data.last_updated);
        console.log("Got last_updated value: " + res.data.last_updated);
      })
      .catch(err => console.log(err));
  }, []);

  React.useEffect(() => {
    if (lastUpdated !== null) {
      axios.get(`/api/manufacturers?t=${lastUpdated}`)
        .then(res => {
          setManufacturers(res.data.results);
          console.log("Got manufacturers: " + res.data.results.length);
        })
        .catch(err => console.log(err));
    }
  }, [lastUpdated]);

  React.useEffect(() => {
    if (lastUpdated !== null) {
      axios.get(`/api/acceptance?t=${lastUpdated}`)
        .then(res => {
          setAcceptanceMarks(res.data.results);
          console.log("Got acceptance marks: " + res.data.results.length);
        })
        .catch(err => console.log(err));
    }
  }, [lastUpdated]);

  React.useEffect(() => {
    if (lastUpdated !== null) {
      axios.get(`/api/units?t=${lastUpdated}`)
        .then(res => {
          setUnitMarkings(res.data.results);
          console.log("Got units: " + res.data.results.length);
        })
        .catch(err => console.log(err));
    }
  }, [lastUpdated]);

  return (
    <React.Fragment>
      <ThemeProvider theme={defaultTheme}>
        <CssBaseline />
        <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
        <HeroImage />
        <Box sx={{ bgcolor: 'background.default' }}>
          <Divider />
          <Database manufacturers={manufacturers} acceptanceMarks={acceptanceMarks} unitMarkings={unitMarkings} lastUpdated={lastUpdated} />
          <Divider />
          <Units unitMarkings={unitMarkings} />
          <Divider />
          <Marks acceptanceMarks={acceptanceMarks} />
          <Divider />
          <About overview={overview} />
          <Footer />
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
}
